import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


const BackLink = ({ link, state, children, isMargined, extraClassName }) => {
  const url = state
    ? ({
      pathname: link,
      state,
    })
    : link;

  return (
    <Link to={url} className={extraClassName}>
      <div className={classNames('link', styles.arrow, { isMargined })}>
        {children}
      </div>
    </Link>
  );
};

BackLink.propTypes = {
  link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  state: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  isMargined: PropTypes.bool,
  extraClassName: PropTypes.string,
};

export default BackLink;
